const DEVICES = {
  mobile: {
    name: 'mobile',
    regExp:
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/,
  },
  tablet: {
    name: 'tablet',
    regExp: /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i,
  },
  desktop: {
    name: 'desktop',
  },
};

export function getDevice() {
  if (DEVICES.tablet.regExp.test(window?.navigator?.userAgent)) {
    return DEVICES.tablet.name;
  }
  if (DEVICES.mobile.regExp.test(window?.navigator?.userAgent)) {
    return DEVICES.mobile.name;
  }
  return DEVICES.desktop.name;
}
